import {pxToRem} from '../../utills/pxToRem'
import {fonts} from '../../theme/foundations/fonts'

export const headerLogoStyle = {
    textDecoration: 'none',
    display: 'block',
    img: {
        width: ['revert-layer', 'revert-layer'],
        height: 'auto'
    }
}

export const cartHeadingStyle = {
    fontFamily: fonts.primary,
    fontWeight: 700,
    fontSize: pxToRem(15),
    color: 'black',
    padding: pxToRem(15),
    paddingLeft: pxToRem(7.5),
    h5: {
        fontWeight: 700
    }
}

export const priceContentStyle = {
    p: {
        fontFamily: fonts.secondary,
        fontSize: pxToRem(13),
        color: 'black'
    },

    '.property-container': {
        display: 'flex',
        flexWrap: 'wrap'
    },

    '.property-item': {
        whiteSpace: 'wrap'
    },

    '.fullWidth': {
        width: '100%'
    },

    '.pipe': {
        padding: '0 7px'
    },

    '.qty-new-line': {
        width: '100%',
        display: 'block',
        marginTop: pxToRem(2)
    }
}

export const priceDiscountContentStyle = {
    fontFamily: fonts.secondary,
    fontSize: pxToRem(13),
    fontWeight: 700,
    textDecoration: 'line-through',
    marginBottom: pxToRem(5)
}

export const cartBodyStyle = {
    maxHeight: pxToRem(300),
    overflowY: 'auto',

    a: {
        display: 'inline-block',
        color: 'black',
        textDecoration: 'none',
        fontFamily: fonts.secondary,
        fontSize: pxToRem(13),
        _hover: {
            outline: 0,
            textDecoration: 'none'
        }
    },
    p: {
        fontSize: pxToRem(13),
        fontFamily: fonts.secondary,
        letterSpacing: pxToRem(1)
    }
}

export const cartBadgeStyle = {
    color: 'white',
    right: [pxToRem(5), pxToRem(5), 0, 0],
    top: [pxToRem(-8), pxToRem(-8), 0, 0]
}

export const cartFooterStyles = {
    backgroundColor: 'cav_deep_light_gray',

    '.mini-cart-subtotals': {
        fontWeight: 700,
        paddingTop: pxToRem(16),
        paddingBottom: pxToRem(20)
    },
    p: {
        margin: 0,
        fontSize: pxToRem(14),
        textTransform: 'uppercase',
        letterSpacing: pxToRem(3),
        fontFamily: fonts.secondary,
        marginBottom: pxToRem(5),
        marginLeft: pxToRem(15)
    },
    '.btn-container': {
        display: 'flex',
        justfyContent: 'center',
        fontFamily: fonts.secondary
    },
    'a.button': {
        textTransform: 'uppercase',
        letterSpacing: pxToRem(3.64),
        backgroundColor: 'cav_clay',
        width: '90%',
        textAlign: 'center',
        padding: `0 ${pxToRem(42)}`,
        lineHeight: pxToRem(44),
        minWidth: pxToRem(180),
        color: 'white',
        fontFamily: fonts.primary,
        ':hover': {
            backgroundColor: 'cav_btn_light_black',
            textDecoration: 'none',
            outline: 0
        }
    }
}

export const menuIconStyle = {
    '.menu-icon': {
        display: 'block',
        backgroundColor: 'white',
        position: 'absolute',
        height: pxToRem(3),
        width: pxToRem(28),
        transition: 'transform 400ms cubic-bezier(0.23, 1, 0.32, 1)',
        borderRadius: pxToRem(2),
        fontSize: '2.0em'
    },
    '.menu-icon::before ': {
        content: `''`,
        marginTop: pxToRem(-8),
        top: '0',
        display: 'block',
        backgroundColor: 'white',
        position: 'absolute',
        height: pxToRem(3),
        width: pxToRem(28),
        transition: 'transform 1000ms cubic-bezier(0.23, 1, 0.32, 1)',
        borderRadius: pxToRem(2)
    },
    '.menu-icon::after ': {
        content: `''`,
        marginTop: pxToRem(8),
        top: '0',
        display: 'block',
        backgroundColor: 'white',
        position: 'absolute',
        height: pxToRem(3),
        width: pxToRem(28),
        transition: 'transform 1000ms cubic-bezier(0.23, 1, 0.32, 1)',
        borderRadius: pxToRem(2)
    }
}

export const toggleMenuIconStyle = {
    '.menu-icon': {
        display: 'block',
        backgroundColor: 'white',
        position: 'absolute',
        height: '0',
        width: pxToRem(28),
        transition: 'transform 400ms cubic-bezier(0.23, 1, 0.32, 1)',
        borderRadius: pxToRem(2),
        fontSize: '2.0em'
    },
    '.menu-icon::before ': {
        content: `''`,
        top: '0',
        display: 'block',
        backgroundColor: 'white',
        position: 'absolute',
        height: pxToRem(3),
        width: pxToRem(28),
        transition: 'transform 1000ms cubic-bezier(0.23, 1, 0.32, 1)',
        borderRadius: pxToRem(2),
        marginTop: '0',
        transform: 'rotate(405deg)'
    },
    '.menu-icon::after ': {
        content: `''`,
        top: '0',
        display: 'block',
        backgroundColor: 'white',
        position: 'absolute',
        height: pxToRem(3),
        width: pxToRem(28),
        transition: 'transform 1000ms cubic-bezier(0.23, 1, 0.32, 1)',
        borderRadius: pxToRem(2),
        marginTop: '0',
        transform: 'rotate(-405deg)'
    }
}

export const giftName = {
    fontFamily: fonts.secondary
}
